import React from 'react';

import { IconScout } from '@/components/ui/images/IconScout';
import type { IconScoutName } from '@/components/ui/images/IconScout';
import { Spinner } from '@/components/ui/loading';
import { Text } from '@/components/ui/text/Text';
import { colors } from '@/assets/styles/colors';


export interface MonitoringColumnHeaderProps {
  /** Icono del pill (Ausentes: userTimes, Justificados: userExclamation, Presentes: userCheck). */
  icon: IconScoutName;
  /** Color del icono; el único valor que varía entre las tres columnas. */
  iconColor: string;
  /** Título ya traducido. */
  title: string;
  /** Muestra el spinner de refresco junto al título. */
  isRefreshing?: boolean;
  /** data-testid del spinner de refresco. */
  refreshingTestId?: string;
}

// Encabezado en pill de las tres columnas del Monitoreo de Asistencia (Ausentes, Justificados,
// Presentes). Según Figma es un pill sobre la tarjeta: fondo blanco, borde delgado, centrado,
// icono + label grande en color primario. Vive en un solo lugar para que las tres columnas queden
// alineadas: la altura mínima es lo que garantiza que las tarjetas hermanas arranquen a la misma
// altura, y el spinner va DENTRO del pill para que aparecer y desaparecer no la altere.
export const MonitoringColumnHeader: React.FC<MonitoringColumnHeaderProps> = ({
  icon,
  iconColor,
  title,
  isRefreshing = false,
  refreshingTestId,
}) => (
  <div className="flex min-h-[3.5rem] items-center justify-center rounded-lg border border-gray-200 bg-white px-6">
    <div className="flex items-center gap-3">
      <IconScout name={icon} size="lg" color={iconColor} />
      <Text variant="header-5" as="h3" color={colors.primary.main}>
        {title}
      </Text>
      {isRefreshing && <Spinner size="sm" data-testid={refreshingTestId} />}
    </div>
  </div>
);

export default MonitoringColumnHeader;
